/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type { ErrorType } from '../../custom-fetch';

import { customFetch } from '../../custom-fetch';
import type {
  DetailError,
  EdiCatalogItemAttachment,
  EdiCatalogItemListParams,
  EdiCatalogItemPage,
  EdiInvitationAcceptRequest,
  EdiInvitationAcceptResponse,
  EdiInvitationValidateRequest,
  EdiInvitationValidateResponse,
  EdiPasswordResetCompleteRequest,
  EdiPasswordResetRequest,
  EdiProfile,
  EdiPublishedNotice,
  EdiPurchaseOrderCreateRequest,
  EdiPurchaseOrderDetailResponse,
  EdiPurchaseOrderListParams,
  EdiPurchaseOrderUpdateRequest,
  EdiTokenMfaRequest,
  EdiTokenObtainRequest,
  EdiTokenObtainResponse,
  EdiTokenObtainUnauthorized,
  EdiTokenOidcRequest,
  EdiTokenOidcResponse,
  EdiTokenRefreshRequest,
  EdiTokenRefreshResponse,
  PaginatedEdiPurchaseOrderList,
  PresignedUrlResponse,
  StandardizedError,
} from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getEdiCatalogItemListUrl = (params?: EdiCatalogItemListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v2/edi/catalog/items?${stringifiedParams}`
    : '/api/v2/edi/catalog/items';
};

/**
 * 選択中の取引先に紐付くカタログのアイテム一覧を取得する。カタログ未設定なら空
 * @summary カタログアイテム一覧取得
 */
export const ediCatalogItemList = async (
  params?: EdiCatalogItemListParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiCatalogItemPage> => {
  return customFetch<EdiCatalogItemPage>(getEdiCatalogItemListUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getEdiCatalogItemListQueryKey = (params?: EdiCatalogItemListParams) => {
  return ['/api/v2/edi/catalog/items', ...(params ? [params] : [])] as const;
};

export const getEdiCatalogItemListQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiCatalogItemListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemList>>> = ({ signal }) =>
    ediCatalogItemList(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ediCatalogItemList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EdiCatalogItemListQueryResult = NonNullable<Awaited<ReturnType<typeof ediCatalogItemList>>>;
export type EdiCatalogItemListQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiCatalogItemList<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | EdiCatalogItemListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemList>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemList<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemList>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemList<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム一覧取得
 */

export function useEdiCatalogItemList<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiCatalogItemListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiCatalogItemListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemList>>> = ({ signal }) =>
    ediCatalogItemList(params, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiCatalogItemListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediCatalogItemList>>
>;
export type EdiCatalogItemListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiCatalogItemListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | EdiCatalogItemListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム一覧取得
 */

export function useEdiCatalogItemListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiCatalogItemListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiCatalogItemAttachmentListUrl = (itemId: number) => {
  return `/api/v2/edi/catalog/items/${itemId}/attachments`;
};

/**
 * 選択中の取引先に紐付くカタログのアイテムに登録されている添付ファイルの一覧を取得する
 * @summary カタログアイテム添付ファイル一覧取得
 */
export const ediCatalogItemAttachmentList = async (
  itemId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiCatalogItemAttachment[]> => {
  return customFetch<EdiCatalogItemAttachment[]>(getEdiCatalogItemAttachmentListUrl(itemId), {
    ...options,
    method: 'GET',
  });
};

export const getEdiCatalogItemAttachmentListQueryKey = (itemId: number) => {
  return [`/api/v2/edi/catalog/items/${itemId}/attachments`] as const;
};

export const getEdiCatalogItemAttachmentListQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiCatalogItemAttachmentListQueryKey(itemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>> = ({ signal }) =>
    ediCatalogItemAttachmentList(itemId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: itemId !== null && itemId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type EdiCatalogItemAttachmentListQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>
>;
export type EdiCatalogItemAttachmentListQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiCatalogItemAttachmentList<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentList<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentList<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム添付ファイル一覧取得
 */

export function useEdiCatalogItemAttachmentList<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemAttachmentListQueryOptions(itemId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiCatalogItemAttachmentListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiCatalogItemAttachmentListQueryKey(itemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>> = ({ signal }) =>
    ediCatalogItemAttachmentList(itemId, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiCatalogItemAttachmentListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>
>;
export type EdiCatalogItemAttachmentListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiCatalogItemAttachmentListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム添付ファイル一覧取得
 */

export function useEdiCatalogItemAttachmentListSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemAttachmentListSuspenseQueryOptions(itemId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiCatalogItemAttachmentDownloadUrlUrl = (itemId: number, attachmentId: number) => {
  return `/api/v2/edi/catalog/items/${itemId}/attachments/${attachmentId}/download-url`;
};

/**
 * @summary カタログアイテム添付ファイルのダウンロードURL取得
 */
export const ediCatalogItemAttachmentDownloadUrl = async (
  itemId: number,
  attachmentId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<PresignedUrlResponse> => {
  return customFetch<PresignedUrlResponse>(getEdiCatalogItemAttachmentDownloadUrlUrl(itemId, attachmentId), {
    ...options,
    method: 'GET',
  });
};

export const getEdiCatalogItemAttachmentDownloadUrlQueryKey = (itemId: number, attachmentId: number) => {
  return [`/api/v2/edi/catalog/items/${itemId}/attachments/${attachmentId}/download-url`] as const;
};

export const getEdiCatalogItemAttachmentDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEdiCatalogItemAttachmentDownloadUrlQueryKey(itemId, attachmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>> = ({
    signal,
  }) => ediCatalogItemAttachmentDownloadUrl(itemId, attachmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: itemId !== null && itemId !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type EdiCatalogItemAttachmentDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>
>;
export type EdiCatalogItemAttachmentDownloadUrlQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiCatalogItemAttachmentDownloadUrl<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentDownloadUrl<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentDownloadUrl<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム添付ファイルのダウンロードURL取得
 */

export function useEdiCatalogItemAttachmentDownloadUrl<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemAttachmentDownloadUrlQueryOptions(itemId, attachmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiCatalogItemAttachmentDownloadUrlSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEdiCatalogItemAttachmentDownloadUrlQueryKey(itemId, attachmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>> = ({
    signal,
  }) => ediCatalogItemAttachmentDownloadUrl(itemId, attachmentId, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never };
  };
};

export type EdiCatalogItemAttachmentDownloadUrlSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>
>;
export type EdiCatalogItemAttachmentDownloadUrlSuspenseQueryError = ErrorType<
  StandardizedError | DetailError
>;

export function useEdiCatalogItemAttachmentDownloadUrlSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentDownloadUrlSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiCatalogItemAttachmentDownloadUrlSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary カタログアイテム添付ファイルのダウンロードURL取得
 */

export function useEdiCatalogItemAttachmentDownloadUrlSuspense<
  TData = Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  itemId: number,
  attachmentId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediCatalogItemAttachmentDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiCatalogItemAttachmentDownloadUrlSuspenseQueryOptions(
    itemId,
    attachmentId,
    options,
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiInvitationAcceptUrl = () => {
  return '/api/v2/edi/invitation-accept';
};

/**
 * @summary EDI招待を承認し、アカウントを作成する
 */
export const ediInvitationAccept = async (
  ediInvitationAcceptRequest: EdiInvitationAcceptRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiInvitationAcceptResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiInvitationAcceptResponse>(getEdiInvitationAcceptUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediInvitationAcceptRequest),
  });
};

export const getEdiInvitationAcceptMutationKey = () => ['ediInvitationAccept'] as const;

export const getEdiInvitationAcceptMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediInvitationAccept>>,
    TError,
    EdiInvitationAcceptMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediInvitationAccept>>,
  TError,
  EdiInvitationAcceptMutationVariables,
  TContext
> => {
  const mutationKey = getEdiInvitationAcceptMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediInvitationAccept>>,
    EdiInvitationAcceptMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediInvitationAccept(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiInvitationAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof ediInvitationAccept>>>;
export type EdiInvitationAcceptMutationBody = EdiInvitationAcceptRequest;
export type EdiInvitationAcceptMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiInvitationAcceptMutationVariables = { data: EdiInvitationAcceptRequest };

/**
 * @summary EDI招待を承認し、アカウントを作成する
 */
export const useEdiInvitationAccept = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediInvitationAccept>>,
      TError,
      EdiInvitationAcceptMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediInvitationAccept>>,
  TError,
  EdiInvitationAcceptMutationVariables,
  TContext
> => {
  return useMutation(getEdiInvitationAcceptMutationOptions(options), queryClient);
};
export const getEdiInvitationValidateUrl = () => {
  return '/api/v2/edi/invitation-accept/validate';
};

/**
 * 既存ユーザーを有効化する副作用があるため POST にしている(v1 は GET)。
 * @summary EDI招待キーを検証する。既存ユーザーの場合はアクティベーションも行う
 */
export const ediInvitationValidate = async (
  ediInvitationValidateRequest: EdiInvitationValidateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiInvitationValidateResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiInvitationValidateResponse>(getEdiInvitationValidateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediInvitationValidateRequest),
  });
};

export const getEdiInvitationValidateMutationKey = () => ['ediInvitationValidate'] as const;

export const getEdiInvitationValidateMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediInvitationValidate>>,
    TError,
    EdiInvitationValidateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediInvitationValidate>>,
  TError,
  EdiInvitationValidateMutationVariables,
  TContext
> => {
  const mutationKey = getEdiInvitationValidateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediInvitationValidate>>,
    EdiInvitationValidateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediInvitationValidate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiInvitationValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof ediInvitationValidate>>
>;
export type EdiInvitationValidateMutationBody = EdiInvitationValidateRequest;
export type EdiInvitationValidateMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiInvitationValidateMutationVariables = { data: EdiInvitationValidateRequest };

/**
 * @summary EDI招待キーを検証する。既存ユーザーの場合はアクティベーションも行う
 */
export const useEdiInvitationValidate = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediInvitationValidate>>,
      TError,
      EdiInvitationValidateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediInvitationValidate>>,
  TError,
  EdiInvitationValidateMutationVariables,
  TContext
> => {
  return useMutation(getEdiInvitationValidateMutationOptions(options), queryClient);
};
export const getEdiPublishedNoticeListUrl = () => {
  return '/api/v2/edi/notices';
};

/**
 * 選択中の取引先の発注先の組織で掲載中のお知らせを、掲載開始日の新しい順に取得する
 * @summary お知らせ一覧取得
 */
export const ediPublishedNoticeList = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiPublishedNotice[]> => {
  return customFetch<EdiPublishedNotice[]>(getEdiPublishedNoticeListUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getEdiPublishedNoticeListQueryKey = () => {
  return ['/api/v2/edi/notices'] as const;
};

export const getEdiPublishedNoticeListQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPublishedNoticeListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPublishedNoticeList>>> = ({ signal }) =>
    ediPublishedNoticeList({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ediPublishedNoticeList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EdiPublishedNoticeListQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediPublishedNoticeList>>
>;
export type EdiPublishedNoticeListQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPublishedNoticeList<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPublishedNoticeList>>,
          TError,
          Awaited<ReturnType<typeof ediPublishedNoticeList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPublishedNoticeList<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPublishedNoticeList>>,
          TError,
          Awaited<ReturnType<typeof ediPublishedNoticeList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPublishedNoticeList<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary お知らせ一覧取得
 */

export function useEdiPublishedNoticeList<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPublishedNoticeListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPublishedNoticeListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPublishedNoticeListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPublishedNoticeList>>> = ({ signal }) =>
    ediPublishedNoticeList({ signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiPublishedNoticeListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediPublishedNoticeList>>
>;
export type EdiPublishedNoticeListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPublishedNoticeListSuspense<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPublishedNoticeListSuspense<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPublishedNoticeListSuspense<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary お知らせ一覧取得
 */

export function useEdiPublishedNoticeListSuspense<
  TData = Awaited<ReturnType<typeof ediPublishedNoticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPublishedNoticeList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPublishedNoticeListSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPasswordResetUrl = () => {
  return '/api/v2/edi/password-reset';
};

/**
 * アカウントの有無を推測させないよう、EDIアカウントが無いメールアドレスでも 204 を返す。
 * @summary EDIアカウントのパスワード再設定メールを送る
 */
export const ediPasswordReset = async (
  ediPasswordResetRequest: EdiPasswordResetRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<null> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<null>(getEdiPasswordResetUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediPasswordResetRequest),
  });
};

export const getEdiPasswordResetMutationKey = () => ['ediPasswordReset'] as const;

export const getEdiPasswordResetMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediPasswordReset>>,
    TError,
    EdiPasswordResetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediPasswordReset>>,
  TError,
  EdiPasswordResetMutationVariables,
  TContext
> => {
  const mutationKey = getEdiPasswordResetMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediPasswordReset>>,
    EdiPasswordResetMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof ediPasswordReset>>>;
export type EdiPasswordResetMutationBody = EdiPasswordResetRequest;
export type EdiPasswordResetMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiPasswordResetMutationVariables = { data: EdiPasswordResetRequest };

/**
 * @summary EDIアカウントのパスワード再設定メールを送る
 */
export const useEdiPasswordReset = <TError = ErrorType<StandardizedError | DetailError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediPasswordReset>>,
      TError,
      EdiPasswordResetMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediPasswordReset>>,
  TError,
  EdiPasswordResetMutationVariables,
  TContext
> => {
  return useMutation(getEdiPasswordResetMutationOptions(options), queryClient);
};
export const getEdiPasswordResetCompleteUrl = () => {
  return '/api/v2/edi/password-reset/complete';
};

/**
 * @summary パスワード再設定メールのキーでEDIアカウントのパスワードを変更する
 */
export const ediPasswordResetComplete = async (
  ediPasswordResetCompleteRequest: EdiPasswordResetCompleteRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<null> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<null>(getEdiPasswordResetCompleteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediPasswordResetCompleteRequest),
  });
};

export const getEdiPasswordResetCompleteMutationKey = () => ['ediPasswordResetComplete'] as const;

export const getEdiPasswordResetCompleteMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediPasswordResetComplete>>,
    TError,
    EdiPasswordResetCompleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediPasswordResetComplete>>,
  TError,
  EdiPasswordResetCompleteMutationVariables,
  TContext
> => {
  const mutationKey = getEdiPasswordResetCompleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediPasswordResetComplete>>,
    EdiPasswordResetCompleteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediPasswordResetComplete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiPasswordResetCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof ediPasswordResetComplete>>
>;
export type EdiPasswordResetCompleteMutationBody = EdiPasswordResetCompleteRequest;
export type EdiPasswordResetCompleteMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiPasswordResetCompleteMutationVariables = { data: EdiPasswordResetCompleteRequest };

/**
 * @summary パスワード再設定メールのキーでEDIアカウントのパスワードを変更する
 */
export const useEdiPasswordResetComplete = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediPasswordResetComplete>>,
      TError,
      EdiPasswordResetCompleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediPasswordResetComplete>>,
  TError,
  EdiPasswordResetCompleteMutationVariables,
  TContext
> => {
  return useMutation(getEdiPasswordResetCompleteMutationOptions(options), queryClient);
};
export const getEdiProfileUrl = () => {
  return '/api/v2/edi/profile';
};

/**
 * @summary EDIユーザーのプロフィール情報を取得する
 */
export const ediProfile = async (options?: Parameters<typeof customFetch>[1]): Promise<EdiProfile> => {
  return customFetch<EdiProfile>(getEdiProfileUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getEdiProfileQueryKey = () => {
  return ['/api/v2/edi/profile'] as const;
};

export const getEdiProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediProfile>>> = ({ signal }) =>
    ediProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ediProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EdiProfileQueryResult = NonNullable<Awaited<ReturnType<typeof ediProfile>>>;
export type EdiProfileQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiProfile<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediProfile>>,
          TError,
          Awaited<ReturnType<typeof ediProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiProfile<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediProfile>>,
          TError,
          Awaited<ReturnType<typeof ediProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiProfile<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDIユーザーのプロフィール情報を取得する
 */

export function useEdiProfile<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediProfile>>> = ({ signal }) =>
    ediProfile({ signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ediProfile>>>;
export type EdiProfileSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiProfileSuspense<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiProfileSuspense<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiProfileSuspense<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDIユーザーのプロフィール情報を取得する
 */

export function useEdiProfileSuspense<
  TData = Awaited<ReturnType<typeof ediProfile>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediProfile>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiProfileSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPurchaseOrderListUrl = (params?: EdiPurchaseOrderListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v2/edi/purchase-orders?${stringifiedParams}`
    : '/api/v2/edi/purchase-orders';
};

/**
 * @summary EDI発注一覧取得(X-Partner-Id の取引先の発注)
 */
export const ediPurchaseOrderList = async (
  params?: EdiPurchaseOrderListParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedEdiPurchaseOrderList> => {
  return customFetch<PaginatedEdiPurchaseOrderList>(getEdiPurchaseOrderListUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getEdiPurchaseOrderListQueryKey = (params?: EdiPurchaseOrderListParams) => {
  return ['/api/v2/edi/purchase-orders', ...(params ? [params] : [])] as const;
};

export const getEdiPurchaseOrderListQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPurchaseOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPurchaseOrderList>>> = ({ signal }) =>
    ediPurchaseOrderList(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ediPurchaseOrderList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EdiPurchaseOrderListQueryResult = NonNullable<Awaited<ReturnType<typeof ediPurchaseOrderList>>>;
export type EdiPurchaseOrderListQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPurchaseOrderList<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | EdiPurchaseOrderListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPurchaseOrderList>>,
          TError,
          Awaited<ReturnType<typeof ediPurchaseOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderList<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPurchaseOrderList>>,
          TError,
          Awaited<ReturnType<typeof ediPurchaseOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderList<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDI発注一覧取得(X-Partner-Id の取引先の発注)
 */

export function useEdiPurchaseOrderList<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPurchaseOrderListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPurchaseOrderListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPurchaseOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPurchaseOrderList>>> = ({ signal }) =>
    ediPurchaseOrderList(params, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiPurchaseOrderListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderList>>
>;
export type EdiPurchaseOrderListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | EdiPurchaseOrderListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDI発注一覧取得(X-Partner-Id の取引先の発注)
 */

export function useEdiPurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: EdiPurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPurchaseOrderListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPurchaseOrderCreateUrl = () => {
  return '/api/v2/edi/purchase-orders';
};

/**
 * @summary EDI発注作成
 */
export const ediPurchaseOrderCreate = async (
  ediPurchaseOrderCreateRequest: EdiPurchaseOrderCreateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiPurchaseOrderDetailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiPurchaseOrderDetailResponse>(getEdiPurchaseOrderCreateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediPurchaseOrderCreateRequest),
  });
};

export const getEdiPurchaseOrderCreateMutationKey = () => ['ediPurchaseOrderCreate'] as const;

export const getEdiPurchaseOrderCreateMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediPurchaseOrderCreate>>,
    TError,
    EdiPurchaseOrderCreateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediPurchaseOrderCreate>>,
  TError,
  EdiPurchaseOrderCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEdiPurchaseOrderCreateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediPurchaseOrderCreate>>,
    EdiPurchaseOrderCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediPurchaseOrderCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiPurchaseOrderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderCreate>>
>;
export type EdiPurchaseOrderCreateMutationBody = EdiPurchaseOrderCreateRequest;
export type EdiPurchaseOrderCreateMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiPurchaseOrderCreateMutationVariables = { data: EdiPurchaseOrderCreateRequest };

/**
 * @summary EDI発注作成
 */
export const useEdiPurchaseOrderCreate = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediPurchaseOrderCreate>>,
      TError,
      EdiPurchaseOrderCreateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediPurchaseOrderCreate>>,
  TError,
  EdiPurchaseOrderCreateMutationVariables,
  TContext
> => {
  return useMutation(getEdiPurchaseOrderCreateMutationOptions(options), queryClient);
};
export const getEdiPurchaseOrderDetailUrl = (id: number) => {
  return `/api/v2/edi/purchase-orders/${id}`;
};

/**
 * @summary EDI発注詳細取得
 */
export const ediPurchaseOrderDetail = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiPurchaseOrderDetailResponse> => {
  return customFetch<EdiPurchaseOrderDetailResponse>(getEdiPurchaseOrderDetailUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getEdiPurchaseOrderDetailQueryKey = (id: number) => {
  return [`/api/v2/edi/purchase-orders/${id}`] as const;
};

export const getEdiPurchaseOrderDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPurchaseOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>> = ({ signal }) =>
    ediPurchaseOrderDetail(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EdiPurchaseOrderDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderDetail>>
>;
export type EdiPurchaseOrderDetailQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof ediPurchaseOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof ediPurchaseOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDI発注詳細取得
 */

export function useEdiPurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPurchaseOrderDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPurchaseOrderDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEdiPurchaseOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>> = ({ signal }) =>
    ediPurchaseOrderDetail(id, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type EdiPurchaseOrderDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderDetail>>
>;
export type EdiPurchaseOrderDetailSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useEdiPurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEdiPurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary EDI発注詳細取得
 */

export function useEdiPurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof ediPurchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof ediPurchaseOrderDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEdiPurchaseOrderDetailSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEdiPurchaseOrderUpdateUrl = (id: number) => {
  return `/api/v2/edi/purchase-orders/${id}`;
};

/**
 * @summary EDI発注更新。未確定の発注のみ。省略した項目は変更しない
 */
export const ediPurchaseOrderUpdate = async (
  id: number,
  ediPurchaseOrderUpdateRequest: EdiPurchaseOrderUpdateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiPurchaseOrderDetailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiPurchaseOrderDetailResponse>(getEdiPurchaseOrderUpdateUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediPurchaseOrderUpdateRequest),
  });
};

export const getEdiPurchaseOrderUpdateMutationKey = () => ['ediPurchaseOrderUpdate'] as const;

export const getEdiPurchaseOrderUpdateMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>,
    TError,
    EdiPurchaseOrderUpdateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>,
  TError,
  EdiPurchaseOrderUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEdiPurchaseOrderUpdateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>,
    EdiPurchaseOrderUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return ediPurchaseOrderUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiPurchaseOrderUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>
>;
export type EdiPurchaseOrderUpdateMutationBody = EdiPurchaseOrderUpdateRequest;
export type EdiPurchaseOrderUpdateMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiPurchaseOrderUpdateMutationVariables = { id: number; data: EdiPurchaseOrderUpdateRequest };

/**
 * @summary EDI発注更新。未確定の発注のみ。省略した項目は変更しない
 */
export const useEdiPurchaseOrderUpdate = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>,
      TError,
      EdiPurchaseOrderUpdateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediPurchaseOrderUpdate>>,
  TError,
  EdiPurchaseOrderUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEdiPurchaseOrderUpdateMutationOptions(options), queryClient);
};
export const getEdiPurchaseOrderDeleteUrl = (id: number) => {
  return `/api/v2/edi/purchase-orders/${id}`;
};

/**
 * @summary EDI発注削除。未確定の発注のみ
 */
export const ediPurchaseOrderDelete = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<null> => {
  return customFetch<null>(getEdiPurchaseOrderDeleteUrl(id), {
    ...options,
    method: 'DELETE',
  });
};

export const getEdiPurchaseOrderDeleteMutationKey = () => ['ediPurchaseOrderDelete'] as const;

export const getEdiPurchaseOrderDeleteMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediPurchaseOrderDelete>>,
    TError,
    EdiPurchaseOrderDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediPurchaseOrderDelete>>,
  TError,
  EdiPurchaseOrderDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getEdiPurchaseOrderDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediPurchaseOrderDelete>>,
    EdiPurchaseOrderDeleteMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return ediPurchaseOrderDelete(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiPurchaseOrderDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof ediPurchaseOrderDelete>>
>;

export type EdiPurchaseOrderDeleteMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiPurchaseOrderDeleteMutationVariables = { id: number };

/**
 * @summary EDI発注削除。未確定の発注のみ
 */
export const useEdiPurchaseOrderDelete = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediPurchaseOrderDelete>>,
      TError,
      EdiPurchaseOrderDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediPurchaseOrderDelete>>,
  TError,
  EdiPurchaseOrderDeleteMutationVariables,
  TContext
> => {
  return useMutation(getEdiPurchaseOrderDeleteMutationOptions(options), queryClient);
};
export const getEdiTokenObtainUrl = () => {
  return '/api/v2/edi/token';
};

/**
 * @summary EDIアカウントでログインしJWTトークンを取得する
 */
export const ediTokenObtain = async (
  ediTokenObtainRequest: EdiTokenObtainRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiTokenObtainResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiTokenObtainResponse>(getEdiTokenObtainUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediTokenObtainRequest),
  });
};

export const getEdiTokenObtainMutationKey = () => ['ediTokenObtain'] as const;

export const getEdiTokenObtainMutationOptions = <
  TError = ErrorType<StandardizedError | EdiTokenObtainUnauthorized | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediTokenObtain>>,
    TError,
    EdiTokenObtainMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediTokenObtain>>,
  TError,
  EdiTokenObtainMutationVariables,
  TContext
> => {
  const mutationKey = getEdiTokenObtainMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediTokenObtain>>,
    EdiTokenObtainMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediTokenObtain(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiTokenObtainMutationResult = NonNullable<Awaited<ReturnType<typeof ediTokenObtain>>>;
export type EdiTokenObtainMutationBody = EdiTokenObtainRequest;
export type EdiTokenObtainMutationError = ErrorType<
  StandardizedError | EdiTokenObtainUnauthorized | DetailError
>;
export type EdiTokenObtainMutationVariables = { data: EdiTokenObtainRequest };

/**
 * @summary EDIアカウントでログインしJWTトークンを取得する
 */
export const useEdiTokenObtain = <
  TError = ErrorType<StandardizedError | EdiTokenObtainUnauthorized | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediTokenObtain>>,
      TError,
      EdiTokenObtainMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediTokenObtain>>,
  TError,
  EdiTokenObtainMutationVariables,
  TContext
> => {
  return useMutation(getEdiTokenObtainMutationOptions(options), queryClient);
};
export const getEdiTokenObtainMfaUrl = () => {
  return '/api/v2/edi/token/mfa';
};

/**
 * @summary EDIログインで返された mfa_token と MFA コードを検証してJWTトークンを取得する
 */
export const ediTokenObtainMfa = async (
  ediTokenMfaRequest: EdiTokenMfaRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiTokenObtainResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiTokenObtainResponse>(getEdiTokenObtainMfaUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediTokenMfaRequest),
  });
};

export const getEdiTokenObtainMfaMutationKey = () => ['ediTokenObtainMfa'] as const;

export const getEdiTokenObtainMfaMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediTokenObtainMfa>>,
    TError,
    EdiTokenObtainMfaMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediTokenObtainMfa>>,
  TError,
  EdiTokenObtainMfaMutationVariables,
  TContext
> => {
  const mutationKey = getEdiTokenObtainMfaMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediTokenObtainMfa>>,
    EdiTokenObtainMfaMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediTokenObtainMfa(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiTokenObtainMfaMutationResult = NonNullable<Awaited<ReturnType<typeof ediTokenObtainMfa>>>;
export type EdiTokenObtainMfaMutationBody = EdiTokenMfaRequest;
export type EdiTokenObtainMfaMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiTokenObtainMfaMutationVariables = { data: EdiTokenMfaRequest };

/**
 * @summary EDIログインで返された mfa_token と MFA コードを検証してJWTトークンを取得する
 */
export const useEdiTokenObtainMfa = <TError = ErrorType<StandardizedError | DetailError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediTokenObtainMfa>>,
      TError,
      EdiTokenObtainMfaMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediTokenObtainMfa>>,
  TError,
  EdiTokenObtainMfaMutationVariables,
  TContext
> => {
  return useMutation(getEdiTokenObtainMfaMutationOptions(options), queryClient);
};
export const getEdiTokenObtainOidcUrl = () => {
  return '/api/v2/edi/token/oidc';
};

/**
 * @summary アニマルID から受け取った認可コードでログインしJWTトークンを取得する
 */
export const ediTokenObtainOidc = async (
  ediTokenOidcRequest: EdiTokenOidcRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiTokenOidcResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiTokenOidcResponse>(getEdiTokenObtainOidcUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediTokenOidcRequest),
  });
};

export const getEdiTokenObtainOidcMutationKey = () => ['ediTokenObtainOidc'] as const;

export const getEdiTokenObtainOidcMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediTokenObtainOidc>>,
    TError,
    EdiTokenObtainOidcMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediTokenObtainOidc>>,
  TError,
  EdiTokenObtainOidcMutationVariables,
  TContext
> => {
  const mutationKey = getEdiTokenObtainOidcMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediTokenObtainOidc>>,
    EdiTokenObtainOidcMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediTokenObtainOidc(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiTokenObtainOidcMutationResult = NonNullable<Awaited<ReturnType<typeof ediTokenObtainOidc>>>;
export type EdiTokenObtainOidcMutationBody = EdiTokenOidcRequest;
export type EdiTokenObtainOidcMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiTokenObtainOidcMutationVariables = { data: EdiTokenOidcRequest };

/**
 * @summary アニマルID から受け取った認可コードでログインしJWTトークンを取得する
 */
export const useEdiTokenObtainOidc = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediTokenObtainOidc>>,
      TError,
      EdiTokenObtainOidcMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediTokenObtainOidc>>,
  TError,
  EdiTokenObtainOidcMutationVariables,
  TContext
> => {
  return useMutation(getEdiTokenObtainOidcMutationOptions(options), queryClient);
};
export const getEdiTokenRefreshUrl = () => {
  return '/api/v2/edi/token/refresh';
};

/**
 * @summary EDIアカウントのアクセストークンを更新する
 */
export const ediTokenRefresh = async (
  ediTokenRefreshRequest: EdiTokenRefreshRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<EdiTokenRefreshResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<EdiTokenRefreshResponse>(getEdiTokenRefreshUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ediTokenRefreshRequest),
  });
};

export const getEdiTokenRefreshMutationKey = () => ['ediTokenRefresh'] as const;

export const getEdiTokenRefreshMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ediTokenRefresh>>,
    TError,
    EdiTokenRefreshMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ediTokenRefresh>>,
  TError,
  EdiTokenRefreshMutationVariables,
  TContext
> => {
  const mutationKey = getEdiTokenRefreshMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ediTokenRefresh>>,
    EdiTokenRefreshMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return ediTokenRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdiTokenRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof ediTokenRefresh>>>;
export type EdiTokenRefreshMutationBody = EdiTokenRefreshRequest;
export type EdiTokenRefreshMutationError = ErrorType<StandardizedError | DetailError>;
export type EdiTokenRefreshMutationVariables = { data: EdiTokenRefreshRequest };

/**
 * @summary EDIアカウントのアクセストークンを更新する
 */
export const useEdiTokenRefresh = <TError = ErrorType<StandardizedError | DetailError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ediTokenRefresh>>,
      TError,
      EdiTokenRefreshMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ediTokenRefresh>>,
  TError,
  EdiTokenRefreshMutationVariables,
  TContext
> => {
  return useMutation(getEdiTokenRefreshMutationOptions(options), queryClient);
};
